export const CURRENT_LOCATION = 'CURRENT_LOCATION'
export const LOCATION_BY_ID = 'LOCATION_BY_ID'



// WEBPACK FOOTER //
// ./src/store/types.js